import Axios from 'axios'
import FetcherHelper from '@/utils/fetcherHelper'
import Config from '@/config'

export default class ObservationPointProxy {
  static get stratesBaseUrl () {
    return `${Config.apiBaseUrl}`
  }

  static get emptyObservationPoint () {
    return {
      name: '',
      publicId: '',
      geom: {
        x: '',
        y: '',
        srs: 2056
      },
      type: ''
    }
  }

  static list () {
    return new Promise((resolve, reject) => {
      Axios.get(`${ObservationPointProxy.stratesBaseUrl}/data/observation-point/`, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static updateRemote (observationPointId, remoteEnabled) {
    return new Promise((resolve, reject) => {
      Axios.patch(`${ObservationPointProxy.stratesBaseUrl}/data/observation-point/${observationPointId}`, {remoteEnabled}, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static addDatasourceRemote (observationPointId) {
    return new Promise((resolve, reject) => {
      Axios.post(`${ObservationPointProxy.stratesBaseUrl}/data/observation-point/data-source/remote/${observationPointId}`, {}, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static get (id) {
    return new Promise((resolve, reject) => {
      Axios.get(`${ObservationPointProxy.stratesBaseUrl}/data/observation-point/${id}`, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static delete (id) {
    return new Promise((resolve, reject) => {
      Axios.delete(`${ObservationPointProxy.stratesBaseUrl}/data/observation-point/${id}`, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static getWellDesc (wellDbk) {
    return new Promise((resolve, reject) => {
      Axios.get(`${ObservationPointProxy.stratesBaseUrl}/regis/quant-es/observation-point/${wellDbk}/desc`, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static getPiezoDesc (wellDbk) {
    return new Promise((resolve, reject) => {
      Axios.get(`${ObservationPointProxy.stratesBaseUrl}/regis/quant-es/observation-point/${wellDbk}/piezo/desc`, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static getRegisIds (stratesId) {
    return new Promise((resolve, reject) => {
      Axios.get(`${ObservationPointProxy.stratesBaseUrl}/data/observation-point/${stratesId}/regis-id`, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static listExportableDatasource (observationPointId) {
    return new Promise((resolve, reject) => {
      Axios.get(`${ObservationPointProxy.stratesBaseUrl}/data/observation-point/${observationPointId}/data-sources/export`, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static getImages (observationPointId) {
    return new Promise((resolve, reject) => {
      Axios.get(`${ObservationPointProxy.stratesBaseUrl}/data/observation-point/${observationPointId}/images`, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static create (observationPoint) {
    return new Promise((resolve, reject) => {
      Axios.post(`${ObservationPointProxy.stratesBaseUrl}/data/observation-point`, observationPoint, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static createWithDatasources(observationPoint, datasources) {
    return new Promise((resolve, reject) => {
      Axios.post(`${ObservationPointProxy.stratesBaseUrl}/data/observation-point-with-datasources`, {...observationPoint, ...datasources }, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static listTypes () {
    return new Promise((resolve, reject) => {
      Axios.get(`${ObservationPointProxy.stratesBaseUrl}/data/observation-point/types`, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }
}